var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntDesignTwitterOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_9359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1967 2.46499C23.3151 2.85093 22.3557 3.12868 21.3674 3.23686C22.3934 2.6183 23.1618 1.64107 23.5283 0.488518C22.5655 1.06973 21.5108 1.47729 20.4109 1.69311C19.9512 1.19439 19.3952 0.797093 18.7776 0.525965C18.1599 0.254836 17.4939 0.115691 16.821 0.1172C14.0983 0.1172 11.9086 2.35681 11.9086 5.10515C11.9086 5.49109 11.9547 5.87703 12.0296 6.24835C7.95279 6.03199 4.31677 4.05552 1.89949 1.02942C1.45903 1.79286 1.22822 2.66213 1.23106 3.54678C1.23106 5.27766 2.09829 6.80386 3.42073 7.70146C2.6414 7.67032 1.88031 7.45294 1.19937 7.067V7.1284C1.19937 9.55221 2.88772 11.5608 5.1379 12.0228C4.7154 12.1342 4.28078 12.1911 3.84426 12.1924C3.52446 12.1924 3.22193 12.1602 2.91653 12.1164C3.53886 14.0928 5.35111 15.5284 7.50909 15.5752C5.82073 16.9172 3.70597 17.7066 1.40969 17.7066C0.997686 17.7066 0.617374 17.692 0.222656 17.6452C2.40081 19.0632 4.9852 19.8819 7.76839 19.8819C16.8037 19.8819 21.7477 12.2859 21.7477 5.69283C21.7477 5.47647 21.7477 5.26011 21.7333 5.04375C22.6899 4.33328 23.5283 3.45322 24.1967 2.46499Z",
    fill: "#21A6DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_9359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.7647,
    fill: "white",
    transform: "translate(0.195312 0.117188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignTwitterOutlined);
export default __webpack_public_path__ + "static/media/ant-design_twitter-outlined.38e76ae44b36accb7e4b2c1250b21bd4.svg";
export { ForwardRef as ReactComponent };